import { reduce } from "lodash";

const SCRIVENER = "syncApplications_SCRIVENER";
const ULYSSES = "syncApplications_ULYSSES";
const NONE = "syncApplications_NONE";

const syncApplications = {
  SCRIVENER,
  ULYSSES,
  NONE
};

export const syncApplicationNames = {
  SCRIVENER: "Scrivener",
  ULYSSES: "Ulysses",
  NONE: "None"
};

export const syncApplicationNamesForConstant = reduce(
  syncApplications,
  (result, str, key) => {
    result[str] = syncApplicationNames[key];
    return result;
  },
  {}
);

export default syncApplications;
